export default __webpack_public_path__ + "static/media/black.0dbf80ed.svg";